import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";
import { SpdrClientViewModel } from "../../../../ViewModel/SpdrClientViewModel";
import { ProjectViewModel } from "../../../../ViewModel/ProjectViewModel";

export function setSameEngineeredSFOnSameSpdrOnEveryRoute(
  project: ProjectViewModel,
  editSpdr: SpdrClientViewModel,
  value: number
) {
  const updatedRoutes: Array<string | undefined> = [];
  const ftlWithNewShipFrequency = project.FTLRoutes?.map((ftlRoute: FtlRouteViewModel) => {
    if (!ftlRoute.SpdrsOnThisRoute) {
      return ftlRoute;
    }

    return {
      ...ftlRoute,
      SpdrsOnThisRoute: ftlRoute.SpdrsOnThisRoute.map((spdr: SpdrClientViewModel) => {
        if (spdr.SpdrId === editSpdr.SpdrId) {
          updatedRoutes.push(ftlRoute.RouteNumber);
          return {
            ...spdr,
            ShipFrequency: value,
          };
        }
        return spdr;
      }),
    };
  });
  return { updatedRoutes, ftlWithNewShipFrequency };
}
